import type { MechKey } from './keys';

export const en: Record<MechKey, string> = {
  'app.eyebrow': 'Physics · Mechanics',
  'panel.scene': 'Scene',
  'panel.dims': 'Parameters',
  'panel.style': 'Appearance',
  'panel.action': 'Controls',
  'style.body': 'Body',
  'style.vector': 'Vectors',
  'style.ground': 'Ground',
  'style.forces': 'Show forces',
  'style.trace': 'Show trace',
  'style.labels': 'Vector labels',
  'hint.line1': 'Click play to start · drag bodies to move them',
  'hint.line2': 'Sandbox: pick a shape, then click to place it',
  'scene.incline': 'Inclined plane',
  'scene.projectile': 'Projectile motion',
  'scene.pendulum': 'Pendulum',
  'scene.springMass': 'Spring-mass system',
  'scene.collisions': 'Collisions',
  'scene.atwood': 'Atwood machine',
  'scene.circular': 'Circular motion',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'angle (°)',
  'dim.friction': 'friction',
  'dim.mass': 'mass',
  'dim.massA': 'mass A',
  'dim.massB': 'mass B',
  'dim.velocity': 'velocity',
  'dim.angleLaunch': 'launch angle (°)',
  'dim.gravity': 'gravity',
  'dim.gravityX': 'gravity x',
  'dim.gravityY': 'gravity y',
  'dim.length': 'length',
  'dim.damping': 'damping',
  'dim.spring': 'stiffness',
  'dim.restitution': 'restitution',
  'dim.radius': 'radius',
  'dim.speed': 'speed',
  'action.play': 'Play',
  'action.pause': 'Pause',
  'action.step': 'Step',
  'action.reset': 'Reset',
  'action.speed': 'Speed',
  'action.clear': 'Clear',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Gravity',
  'forceName.normal': 'Normal',
  'forceName.friction': 'Friction',
  'forceName.tension': 'Tension',
  'forceName.spring': 'Spring',
  'forceName.applied': 'Applied',
  'forceName.air': 'Air drag',
  'palette.box': 'Box',
  'palette.circle': 'Ball',
  'palette.ramp': 'Ramp',
  'palette.ground': 'Ground',
  'palette.hint': 'Pick a shape, then click on the canvas to place it.',
  'panel.forces': 'Forces seen',
  'forces.empty': 'None yet — play the scene',
};
